<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    $route(to) {
      if (to.meta && to.meta.title) {
        document.title = to.meta.title
      }
    }
  },
  mounted() {
    const title = this.$route.meta && this.$route.meta.title
    if (title) document.title = title
  }
}
</script>
